import { LANGUAGE_EN } from '@edulastic/constants/const/languages'
import React from 'react'

const LanguageContext = React.createContext({
  currentLanguage: 'en',
  languageTabs: [LANGUAGE_EN],
})

export default LanguageContext
